module.exports = __webpack_public_path__ + "static/media/icon_time.a86f54bc.svg";